module.exports = __webpack_public_path__ + "img/background.d6adf411.jpg";